export default import.meta.ROLLDOWN_FILE_URL_dU_Zp0a7h267LjUI_0xdjw